import React from 'react'

const MajorWave = props => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 5.89A4 4 0 012 7.3a.75.75 0 010-1.49 2.54 2.54 0 002-1A4 4 0 017 3.4a4 4 0 013 1.4 2.6 2.6 0 002 1 2.56 2.56 0 002-1 3.93 3.93 0 016 0 2.54 2.54 0 002 1 .75.75 0 010 1.5 4 4 0 01-3-1.41 2.48 2.48 0 00-4 0 4 4 0 01-3 1.41 4 4 0 01-3-1.41 2.58 2.58 0 00-2-1 2.58 2.58 0 00-2 1zm17 6.56a2.58 2.58 0 01-2-1 3.93 3.93 0 00-6 0 2.49 2.49 0 01-4 0 4 4 0 00-3-1.41 4 4 0 00-3 1.41 2.58 2.58 0 01-2 1A.775.775 0 102 14a4 4 0 003-1.41 2.58 2.58 0 012-1 2.58 2.58 0 012 1A4 4 0 0012 14a4 4 0 003-1.41 2.47 2.47 0 014 0A4 4 0 0022 14a.75.75 0 000-1.5v-.05zm.75 7.4a.76.76 0 01-.75.75 4 4 0 01-3-1.41 2.47 2.47 0 00-4 0 4 4 0 01-3 1.41 4 4 0 01-3-1.41 2.54 2.54 0 00-2-1 2.58 2.58 0 00-2 1 4 4 0 01-3 1.41.75.75 0 010-1.5 2.58 2.58 0 002-1 4 4 0 013-1.4 4 4 0 013 1.41 2.49 2.49 0 004 0 3.93 3.93 0 016 0 2.58 2.58 0 002 1 .76.76 0 01.75.74z"
      fill={props.fill || '#fff'}
    />
  </svg>
  )

export default MajorWave
